import { render, staticRenderFns } from "./PhotoCarousel.vue?vue&type=template&id=3087a848&"
import script from "./PhotoCarousel.vue?vue&type=script&lang=ts&"
export * from "./PhotoCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCard,VCardText,VCardTitle,VCarousel,VCarouselItem})
